
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/policy-two",
      function () {
        return require("private-next-pages/nl/policy-two.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/policy-two"])
      });
    }
  